module.exports = __webpack_public_path__ + "static/media/forgot-password.a29210f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forgot-password.jpg
// module id = 369
// module chunks = 33